// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmailCommunicationView
 */
export interface IEmailCommunicationView {
    /**
     * 
     * @type {string}
     * @memberof IEmailCommunicationView
     */
    type: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof IEmailCommunicationView
     */
    template_variables?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof IEmailCommunicationView
     */
    template_id?: number;
}

/**
 * Check if a given object implements the IEmailCommunicationView interface.
 */
export function instanceOfIEmailCommunicationView(value: object): value is IEmailCommunicationView {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function IEmailCommunicationViewFromJSON(json: any): IEmailCommunicationView {
    return IEmailCommunicationViewFromJSONTyped(json, false);
}

export function IEmailCommunicationViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmailCommunicationView {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'template_variables': json['template_variables'] == null ? undefined : json['template_variables'],
        'template_id': json['template_id'] == null ? undefined : json['template_id'],
    };
}

export function IEmailCommunicationViewToJSON(json: any): IEmailCommunicationView {
    return IEmailCommunicationViewToJSONTyped(json, false);
}

export function IEmailCommunicationViewToJSONTyped(value?: IEmailCommunicationView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'template_variables': value['template_variables'],
        'template_id': value['template_id'],
    };
}

